/**
 * The brand name is bold in every piece of copy (Leo, 2026-09-28). One matcher
 * for the whole platform: the website's static pages are rewritten by
 * scripts/bold_brand.py with the same pattern, and the dashboard and trust apps
 * render copy through brandSegments. URLs and identifiers are not matches:
 * github.com/ComplyEdge/complyedge and ComplyEdgeClient stay as they are.
 */
export const BRAND = 'ComplyEdge'
export const BRAND_PATTERN = /(?<![\w/.@-])ComplyEdge(?![\w/-])(?!(?<=“ComplyEdge)”)/g

/** "Why ComplyEdge?" -> [{text:"Why ",brand:false},{text:"ComplyEdge",brand:true},{text:"?",brand:false}] */
export function brandSegments(text) {
  const out = []
  let last = 0
  for (const m of String(text).matchAll(BRAND_PATTERN)) {
    if (m.index > last) out.push({ text: text.slice(last, m.index), brand: false })
    out.push({ text: m[0], brand: true })
    last = m.index + m[0].length
  }
  if (last < String(text).length) out.push({ text: String(text).slice(last), brand: false })
  return out
}
